<script>
import { defineComponent, h, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { PontotelSeletor as PontotelSeletorImaginii } from '@Lar21/imaginii-web-components/lib/vue'

const PROPRIEDADES_EXPOSTAS = [
  'estaAberto',
  'consultaBusca',
  'carregandoItens',
  'itensFiltrados',
  'entradasVirtualizadas',
  'itensVirtualizados',
  'itensSelecionados',
  'selecionarTodosAtivo',
  'inputRef'
]

const METODOS_EXPOSTOS = [
  'alternarDropdown',
  'abrirDropdown',
  'manipularInput',
  'manipularRolagem',
  'selecionarItem',
  'alternarSelecionarTodos',
  'removerItem',
  'itemEstaSelecionado',
  'limparCampoDePesquisa'
]

export default defineComponent({
  name: 'PontotelSeletor',
  inheritAttrs: false,
  props: {
    traducaoNenhumResultado: { type: String, default: undefined },
    traducaoSelecionado: { type: String, default: undefined },
    traducaoSelecionadosPlural: { type: String, default: undefined },
    traducaoItens: { type: String, default: undefined },
    traducaoSelecionarTodos: { type: String, default: undefined },
    traducaoRecarregarTodos: { type: String, default: undefined },
    traducaoRecarregado: { type: String, default: undefined }
  },
  setup (props, { attrs, slots, expose }) {
    const { t } = useI18n({ useScope: 'global' })
    const seletor = ref(null)
    const apiExposta = {}

    PROPRIEDADES_EXPOSTAS.forEach((propriedade) => {
      Object.defineProperty(apiExposta, propriedade, {
        enumerable: true,
        get: () => seletor.value?.[propriedade]
      })
    })
    METODOS_EXPOSTOS.forEach((metodo) => {
      apiExposta[metodo] = (...argumentos) => seletor.value?.[metodo]?.(...argumentos)
    })
    expose(apiExposta)

    const obterTraducao = (propriedade, chave) => (
      props[propriedade] ?? t(`compartilhados.selectors.PontotelSeletor.${chave}`)
    )

    return () => h(PontotelSeletorImaginii, {
      ...attrs,
      ref: seletor,
      traducaoNenhumResultado: obterTraducao('traducaoNenhumResultado', 'nenhumResultado'),
      traducaoSelecionado: obterTraducao('traducaoSelecionado', 'selecionado'),
      traducaoSelecionadosPlural: obterTraducao('traducaoSelecionadosPlural', 'selecionadosPlural'),
      traducaoItens: obterTraducao('traducaoItens', 'itens'),
      traducaoSelecionarTodos: obterTraducao('traducaoSelecionarTodos', 'selecionarTodos'),
      traducaoRecarregarTodos: obterTraducao('traducaoRecarregarTodos', 'recarregarTodos'),
      traducaoRecarregado: obterTraducao('traducaoRecarregado', 'recarregado')
    }, slots)
  }
})
</script>
